import { render } from "./WhatsAppView.vue?vue&type=template&id=3b9cde1d&scoped=true"
import script from "./WhatsAppView.vue?vue&type=script&lang=js"
export * from "./WhatsAppView.vue?vue&type=script&lang=js"

import "./WhatsAppView.vue?vue&type=style&index=0&id=3b9cde1d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b9cde1d"]])

export default __exports__